<template>
  <div class="comp-header-left">
    <div class="btn" v-on:click="PDLClick">
      <i class="fas" :class="PDLIcon"></i>
      <span class="btn-txt">{{ PDLLink }}</span>
      <span class="badge" v-if="PDLBadge">{{ PDLBadge }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header-left',
  props: {
    PDLIcon: String,
    PDLLink: String,
    PDLBadge: String,
    PDLClick: {
      type: Function,
      default() {
        return null;
      },
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-header-left.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompHeaderLeft.vue